export default {
  fontSize: '2rem',
  letterSpacing: 'normal',
  margin: '0.7em auto 0 0',
};
